import MyMissionExcerpt from '@/components/MyMissionExcerpt/MyMissionExcerpt.vue';

export default {
    components: {
        MyMissionExcerpt,
    },
};
